import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { AppealsService } from 'src/app/services/appeals.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-search-violations',
  templateUrl: './search-violations.page.html',
  styleUrls: ['./search-violations.page.scss'],
})
export class SearchViolationsPage implements OnInit {
  @ViewChild('searchInput') searchInput:IonSearchbar;
  constructor(
    public dataService: DataService,
    public modalController: ModalController,
    public appealsSRV: AppealsService,
  ) { }

  ngOnInit() {
    this.appealsSRV.searchData['violations']=[]
  }
  
  onCancelModal() {
   
    this.modalController.dismiss({
      dismissed: true,
    });
  }
  ionViewDidEnter() {
  
    
    this.searchInput.setFocus()
  }

}
